import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../store/actions/actions';
import Email from '../../../models/Email';
import { useConfig } from '../../../utils/config';
import { Dumb } from '..';
const AddCollaborator = () => {
  const dispatch = useDispatch();
  const {
    prefill,
    clearPrefillField
  } = useConfig();
  const {
    contacts,
    individualAddCollaboratorsPermissions,
    collaboratorCount
  } = useSelector(state => {
    var _state$userPermission;
    return {
      contacts: state.contacts.value,
      individualAddCollaboratorsPermissions: (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.collaborator.individual.add,
      collaboratorCount: state.collaborators.value.allIds.length
    };
  });
  const handleAdd = (email, permission) => {
    clearPrefillField('addCollaboratorEmail');
    dispatch(actions.updateCollaborator(email, permission));
  };
  return individualAddCollaboratorsPermissions ? React.createElement(Dumb.AddCollaborator, {
    individualAddCollaboratorsPermissions: individualAddCollaboratorsPermissions,
    contacts: contacts,
    handleAdd: handleAdd,
    collaboratorCount: collaboratorCount,
    initialEmail: (prefill === null || prefill === void 0 ? void 0 : prefill.addCollaboratorEmail) ? Email.fromString(prefill.addCollaboratorEmail) : undefined
  }) : null;
};
export default AddCollaborator;